export default __webpack_public_path__ + "static/media/franky_logo_Curve (2).be51d99b.svg";